import { PropsWithChildren, ReactNode } from "react"
import { makeStyles } from "tss-react/mui"
import { Grid, Typography } from "@mui/material"
import { StandardDialog } from "../../dialogs/StandardDialog"
import { StandardButton } from "../../buttons/StandardButton"

type AbandonBookingDialogProps = Readonly<
    PropsWithChildren<{
        open: boolean
        onClose: () => void
        title: ReactNode
        message?: ReactNode
        handleSubmitClick(): void
        handleCancelClick(): void
        buttonLabelSubmit: string
        buttonLabelCancel: string
    }>
>

const useStyles = makeStyles()((theme) => ({
    dialogPaper: {
        minHeight: "20rem",
        justifyContent: "center",
    },
    container: {
        padding: "0 4rem 1.5rem",
        gap: "2rem",
    },
    dialogTitle: {
        textAlign: "center",
        fontWeight: 600,
        paddingBottom: "0.75rem",
        color: theme.palette.tailwind.slate[950],
    },
    subTitle: {
        color: theme.palette.tailwind.slate[950],
    },
    button: {
        borderRadius: "0.5rem",
        paddingLeft: "2rem",
        paddingRight: "2rem",
    },
    cancelButton: {
        color: theme.palette.tailwind.slate[800],
    },
    successButton: {
        background: theme.palette.tailwind.slate[800],
        borderColor: theme.palette.tailwind.slate[300],
    },
}))

export function AbandonBookingDialog({
    open,
    onClose,
    title,
    message = "",
    handleSubmitClick,
    handleCancelClick,
    buttonLabelSubmit,
    buttonLabelCancel,
    children,
}: AbandonBookingDialogProps) {
    const { classes, cx } = useStyles()

    return (
        <StandardDialog
            open={open}
            onClose={onClose}
            maxWidthProp="sm"
            dialogTitle={title}
            slotProps={{ paper: { className: classes.dialogPaper } }}
        >
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                direction="column"
                wrap="nowrap"
                className={classes.container}
            >
                <Typography variant="body1" textAlign="center" className={classes.subTitle}>
                    {message}
                </Typography>
                {children}
                <Grid container direction="row" wrap="nowrap" alignItems="center" justifyContent="center" gap="1rem">
                    <StandardButton
                        color="grey"
                        variant="outlined"
                        onClick={() => {
                            handleCancelClick()
                        }}
                        size="medium"
                        className={cx(classes.cancelButton)}
                        updateDefaultClasses={classes.button}
                    >
                        {buttonLabelCancel}
                    </StandardButton>
                    <StandardButton
                        onClick={() => {
                            handleSubmitClick()
                        }}
                        size="medium"
                        className={cx(classes.successButton)}
                        updateDefaultClasses={classes.button}
                    >
                        {buttonLabelSubmit}
                    </StandardButton>
                </Grid>
            </Grid>
        </StandardDialog>
    )
}
